import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import { useEffect, useState } from 'react'
import ECharts from '~/components/echarts'
import {
  awsSummarySavingsOrganizationOptimizerAWSMasterOptimizationsPath,
  ebsOptimizedVolumeKindChartsOrganizationOptimizerAWSMasterOptimizationsPath,
  ebsStorageCostAnalysisChartOrganizationOptimizerAWSMasterOptimizationsPath,
  ebsVolumeKindChartsOrganizationOptimizerAWSMasterOptimizationsPath,
} from '~/routes'
import { csrfHeader } from '~/utils/csrf'

export default function StorageOptimization({ organizationId, masterOptimizationId, masterOptimization }) {
  const [activeTab, setActiveTab] = useState('daily-cost')
  const [savingsData, setSavingsData] = useState(null)

  // biome-ignore lint/correctness/useExhaustiveDependencies: todo: re-evaluate dependencies
  useEffect(() => {
    if (masterOptimization) {
      fetchSavingsData()
    }
  }, [masterOptimization])

  const fetchSavingsData = async () => {
    try {
      const savingsUrl = awsSummarySavingsOrganizationOptimizerAWSMasterOptimizationsPath(organizationId)
      const response = await fetch(savingsUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...csrfHeader(),
        },
        body: JSON.stringify({ master_optimization_id: masterOptimizationId }),
      })

      if (response.ok) {
        const data = await response.json()
        setSavingsData(data)
      } else {
        console.error('Failed to fetch Storage savings data:', response.status, response.statusText)
      }
    } catch (error) {
      console.error('Error fetching Storage savings data:', error)
    }
  }

  if (!masterOptimization) {
    return null
  }

  const handleTabChange = (tabId) => {
    setActiveTab(tabId)
  }

  const dailySavings = savingsData?.storage_savings?.daily_savings || 0
  const savingsPercentage = savingsData?.storage_savings?.savings_percentage || 0

  return (
    <div className='row mb-4'>
      <div className='col-12'>
        <div className='card'>
          <div className='card-header'>
            <h5 className='card-title mb-0'>
              <Trans>
                Storage Optimization - Daily Savings ${dailySavings.toFixed(2)} ({savingsPercentage.toFixed(1)}%)
              </Trans>
            </h5>
          </div>
          <div className='card-body'>
            <ul className='nav nav-tabs mb-3'>
              <li className='nav-item'>
                <button
                  className={`nav-link ${activeTab === 'daily-cost' ? 'active' : ''}`}
                  onClick={() => handleTabChange('daily-cost')}
                  type='button'
                >
                  <Trans>Daily Cost</Trans>
                </button>
              </li>
              <li className='nav-item'>
                <button
                  className={`nav-link ${activeTab === 'volume-kind' ? 'active' : ''}`}
                  onClick={() => handleTabChange('volume-kind')}
                  type='button'
                >
                  <Trans>Volume Kind</Trans>
                </button>
              </li>
            </ul>

            <div className='mt-3'>
              {activeTab === 'daily-cost' && (
                <div className='wider-chart-container'>
                  <ECharts
                    title={t`EBS Storage Daily Cost Comparison`}
                    chartInfoTitle='aws_ebs_optimization_daily_cost_comparison'
                    url={ebsStorageCostAnalysisChartOrganizationOptimizerAWSMasterOptimizationsPath(organizationId)}
                    params={{ master_optimization_id: masterOptimizationId }}
                  />
                </div>
              )}

              {activeTab === 'volume-kind' && (
                <div className='row'>
                  <div className='col-md-6'>
                    <ECharts
                      title={t`Current Volume Kinds`}
                      chartInfoTitle='aws_ebs_current_volume_kinds'
                      url={ebsVolumeKindChartsOrganizationOptimizerAWSMasterOptimizationsPath(organizationId)}
                      params={{ master_optimization_id: masterOptimizationId }}
                    />
                  </div>
                  <div className='col-md-6'>
                    <ECharts
                      title={t`Optimized Volume Kinds`}
                      chartInfoTitle='aws_ebs_optimized_volume_kinds'
                      url={ebsOptimizedVolumeKindChartsOrganizationOptimizerAWSMasterOptimizationsPath(organizationId)}
                      params={{ master_optimization_id: masterOptimizationId }}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
